import { render, staticRenderFns } from "./AccountNftInventoryTable.vue?vue&type=template&id=4d94314e&scoped=true"
import script from "./AccountNftInventoryTable.vue?vue&type=script&lang=js"
export * from "./AccountNftInventoryTable.vue?vue&type=script&lang=js"
import style0 from "./AccountNftInventoryTable.vue?vue&type=style&index=0&id=4d94314e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d94314e",
  null
  
)

export default component.exports